<script>
    import { brushes } from "./brushes.js";
    import { Button, Icon, Popover } from "sveltestrap";
    import { createEventDispatcher, onMount, tick } from "svelte";
    import store from "../store";
    import { _log } from "../utils/logger";
  import IFabric from "../utils/fabric-helper.js";

    let dispatcher = createEventDispatcher();
    let isFirstCall = true;
    let isOpen = false;
    let boxBtnEl;
    let boxEl;
    let isActive = false;

    const onClickHandler = (e) => {
        const classList = Array.from(e.target.parentNode.classList);
        _log("onClickHandler", classList);
        if (
            !classList.some(
                (v) => v.startsWith("boxP") || v.startsWith("add-btn")
            )
        ) {
            isOpen = false;
        }
    };
    $: if (isOpen) {
        _log("addEventListener");
        setTimeout(() => {
            window.addEventListener("click", onClickHandler);
        }, 0);
    }
    $: if (!isOpen) {
        _log("removeEventListener");
        window.removeEventListener("click", onClickHandler);
    }

    $: if(IFabric.store.typeBrush){
        currentImgUrl = `/brush/${IFabric.store.typeBrush}.png`;
    }

    let brushesAll = [];
    onMount(() => {
        brushesAll = [];
        //store.setValue("typeBrush", "pencil");
        for (const brush of brushes) {
            brushesAll.push({ name: brush, url: `/brush/${brush}.png` });
        }
        brushesAll = brushesAll;
        fabricHelper.brush.updateBrush();
    });

    function imgClickHandler(brush) {
        _log("imgClickHandler", brush.url);
        store.setValue("typeBrush", brush.name);
        boxBtnEl.src = brush.url;
        currentImgUrl = brush.url;
    }

    function toggleBox() {
        isOpen = !isOpen;
    }

    let currentImgUrl = `/brush/${IFabric.store.typeBrush}.png`;
    function closeBox() {
        isOpen = false;
    }
</script>

<div class="brushSelectedImg">
    <img
        class="noselect"
        class:activeColor={isActive}
        alt=""
        src={currentImgUrl}
        id="boxBrushBtn"
        bind:this={boxBtnEl}
        on:click={toggleBox}
    />
</div>
{#if isOpen}
    <div tabindex="0" class="boxB" bind:this={boxEl}>
        <div class="flex p-1">
            {#each brushesAll as brush}
                <figure
                    on:click={closeBox}
                    class:active={brush.url === currentImgUrl}
                >
                    <img
                        class="imgPreview"
                        src={brush.url}
                        alt=""
                        on:click={(e) => imgClickHandler(brush)}
                    />
                </figure>
            {/each}
        </div>
    </div>
{/if}

<style>
    .brushSelectedImg {
        margin-left: 2px;
        padding: 0;
        width: 98%;
        margin-bottom: 10px;
    }

    .active {
        box-shadow: 0 0 4px red, 0 1px 12px var(--main-color);
    }
    #boxBrushBtn {
        box-shadow: 0 0 2px var(--main-color);
        border-radius: 2px;
        margin-top: 0 auto;
        max-height: 100px;
        width: 100%;
        padding: 0;
        cursor: pointer;
    }

    #boxBrushBtn:hover {
        box-shadow: 0 0 4px var(--main-color);
    }

    :global(#deletePattern) {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
    }

    figure {
        margin: 5px;
        position: relative;
    }

    .imgPreview {
        width: 80px;
        height: 50px;
        cursor: pointer;
    }

    .boxB {
        max-width: 370px;
        position: fixed;
        top: 0;
        left: 245px;
        z-index: 989889844343;
        box-shadow: 0 1px 12px var(--main-color);
        background: var(--trnasparent-white-color);
    }
</style>
